import { createActionCreators } from 'store/utils/actionHelpers';
import types from './types';
import CmsApis from 'apis/cmsApis';

const preferences = {
  mcJeans: {
    storeId: 'mcJeans',
    storeName: 'McJeans',
    logo: 'https://obs.line-scdn.net/0m01a3c6f25b17725c67637c1f137667753f63303b235f2e4b4579203d2b7e3b2d3a77353134633b5c3f7a?0m01a3c6f25b17725c67637c1f137667753f63303b235f2e4b4579203d2b7e3b2d3a77353134633b5c3f7a',
    font: {
      color: '#ffffff',
      family: [
        {
          label: 'Roboto',
          value: 'Roboto',
        },
      ],
    },
    background: {
      color: '#000000',
      image: '',
    },
    css: 'https://s3-ap-southeast-1.amazonaws.com/cms.alpha.incart/mcJeans/v1/css/semantic.min.css',
  },
  superdry: {
    storeId: 'superdry',
    storeName: 'Superdry',
    logo: 'https://s3-ap-southeast-1.amazonaws.com/cms.alpha.incart/superdry/v1/media/site-logo.png',
    font: {
      color: '#ffffff',
      family: [
        {
          label: 'Roboto',
          value: 'Roboto',
        },
      ],
    },
    background: {
      color: '#000000',
      image: '',
    },
    css: 'https://s3-ap-southeast-1.amazonaws.com/cms.alpha.incart/superdry/v1/css/semantic.min.css',
  },
};

export const {
  fetchThemeRequest,
  fetchThemeSuccess,
  fetchThemeFailure,
} = createActionCreators(types);

export const fetchTheme = storeId => (dispatch) => {
  dispatch(fetchThemeRequest());
  return CmsApis.getStoreTheme(storeId)
    .then(({ data }) => {
      return dispatch(fetchThemeSuccess({
        theme: data,
        preferences: preferences[storeId],
      }))
    })
    .catch(error => dispatch(fetchThemeFailure({ error })));
};



// WEBPACK FOOTER //
// ./src/store/theme/actions.js